import { trackEvent } from 'dibs-tracking';

export function trackTranslationToggle(): void {
    trackEvent({
        category: 'product',
        action: 'item details - toggle language click',
        label: 'pdp - intl',
        isInteractiveEvent: true,
    });
}
